import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import '../../css/InstantScreens/Instant.css';

import { StringUtils, ArrayUtils } from '../../utils';
import { History as history, Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, PracticeStaff, PracticeAdmins, SingleScreenNavBar, Header, Input, PhoneInput, Line, PracticeLocationClients } from  '../../components'

class PracticeLocationClientsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      token: '',
      location: {},
      location_id: '',
      locations: [],
      clients: [],
      jump_page: '',
    }
  }

  componentDidMount() {
    let props       = this.props.location.state.props;
    let location_id = props.location._id;
    let token       = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : this.props.user.auth.token;
    let loc_arr     = this.getLocationsArray(this.props.practice.locations);
    this.props.practiceActions.getClientListForLocation(location_id, null, null, null, this.setClientsArray);
    this.setState({ ...this.state, token: token, location_id: location_id, location: props.location, locations: loc_arr });
  }

  renderClientListSection = () => {
    return <div className="flex-container screen-main-content" style={{ }}>
      <div className='flex-container-column' style={{ width: 300, height: 500, marginTop: 25, marginRight: 25 }}>
        { this.renderLocationSelection()    }
      </div>
      <div className='flex-container-column' style={{ width: 500, height: 500, marginTop: 25, marginRight: 25 }}>
        { this.renderClientsList() }
      </div>
    </div>
  }

  renderLocationSelection = () => {
    let locations = this.state.locations;

    let location_rows = locations.map((location, index) => {
      let is_selected = this.state.location_id === location._id;
      let name        = location.name;
      let bottom_marg = locations.length === index + 1 ? 0 : 5;
      let border_clr  = is_selected ? '#1dc2ff' : '';
      return <div className='color-button-border flex-container-row'
                  style={{ borderColor: border_clr, marginBottom: bottom_marg, padding: 8, borderWidth: 2, borderRadius: 5, justifyContent: 'space-between', alignItems: 'center' }}
                  onClick={ () => {
                    this.props.practiceActions.getClientListForLocation(location._id, null, null, 1, this.setClientsArray);
                    this.setState({ ...this.state, location_id: location._id, location: location });
                  }}>
        <span style={{ color: '#575757', fontSize: 13 }}>{ name }</span>
        <span className='fas fa-check-circle' style={{ color: is_selected ? '#1dc2ff' : 'white', fontSize: 13 }} />
      </div>
    }).filter((row) => { return row });

    return <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
      <Header title='Select Location' icon='fas fa-map-marker-alt' />
      <div className='flex-container-column' style={{ padding: 15 }}>
        { location_rows }
      </div>
    </div>
  }

  renderClientsList = () => {
    let location = this.state.location;
    let name     = StringUtils.displayName(location);
    let title    = 'Clients at ' + name;

    let client_rows  = this.getClientRows();
    let display_none = client_rows.length === 0 ? true : false;

    return <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
      <Header title={title} icon='fas fa-users' />
      <div className='flex-container-column'>

        { client_rows }
        { display_none ? <div style={{ fontSize: 13, color: 'grey', padding: 30, textAlign: 'center' }}>There are no clients to display on this page</div> : null }
        <Line />
        { this.renderFooterSection() }
      </div>
    </div>
  }

  renderFooterSection = (page_state, arr) => {
    let current_page_state  = this.props.practice && this.props.practice.clientsPageState ? this.props.practice.clientsPageState : {};
    let page_number         = current_page_state.page_number || 1;
    let display_prev_btn    = page_number > 1;
    let display_next_btn    = true;

    return <div className='flex-container-row' style={{ padding: 8, paddingLeft: 15, justifyContent: 'space-between', alignItems: 'center' }}>
      <div className='flex-container-row' style={{  }}>
        <Input  value={ this.state.jump_page }
                placeholder="#"
                className='input-default-border'
                style={{ fontSize: 13, width: 40, textAlign: 'center', marginRight: 5 }}
                onChange={ (event) => {
                  this.setState({ ...this.state, jump_page: event.target.value });
                }}
              />
        <span className='header-button'
              onClick={ () => {
                let page_num = parseInt(this.state.jump_page);
                this.props.practiceActions.getClientListForLocation(null, null, true, page_num, this.setClientsArray);
                this.setState({ ...this.state, jump_page: '' });
              }}>Page Jump</span>
      </div>
      <div className='flex-container-row' style={{ alignItems: 'center' }}>
        { display_prev_btn ? <div className='header-button' onClick={ () => { this.props.practiceActions.getClientListForLocation(null, null, true, null, this.setClientsArray) }}>Previous</div> : null }
        <span style={{ marginRight: 12, marginLeft: 10 }}>{ page_number }</span>
        { display_next_btn ? <div className='header-button' onClick={ () => { this.props.practiceActions.getClientListForLocation(null, true, null, null, this.setClientsArray) }}>Next</div> : null }
      </div>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Clients List" />
        { this.renderClientListSection() }
      </div>
    );
  }

  getClientRows = () => {
    let clients     = this.state.clients;
    let client_rows = []

    clients.forEach((client_obj) => {
      let user = ArrayUtils.getSingleObject(client_obj.user_details);
      let name = StringUtils.displayName(user);
      client_rows.push(
        <div className='flex-container-column'>
          <div className='standard-selection-row' key={user._id} style={{ padding: 8, paddingLeft: 15 }}
               onClick={ () => {
                 let screen_props = {
                   user_id: user._id,
                 }
                 history.push({ pathname: routes.CLIENT_DETAILS, state: { props: screen_props } })
               }}>
            <span style={{ color: '#575757', fontSize: 13 }}>{ name }</span>
          </div>
          <Line style={{ backgroundColor: '#f5f5f5' }} />
        </div>
      );
    });


    return client_rows;
  }

  getLocationsArray = (locations_obj) => {
    let locations_arr = Object.values(locations_obj);
    return locations_arr;
  }

  setClientsArray = (clients) => {
    this.setState({ ...this.state, clients: clients });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeLocationClientsScreen)
